import { atom } from 'jotai'
import { loadable } from 'jotai/utils'
import { userService } from './services/userService'

export type User = {
  email: string
  id: string
  name: string
}

export const userBaseAtom = atom(async () => {
  return await userService.getCurrentUser()
})

export const userAtom = loadable(userBaseAtom)
